import revive_payload_client_4sVQNw7RlN from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_9gMxCtyFUG from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt-site-config/dist/runtime/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import route_locale_detect_VrpP1JaYg8 from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/route-locale-detect.js";
import i18n_sq1MuCrqbC from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_vue3_YdLad5Mpq3 from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/vsts/work/1/s/webapp-ots-nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import nuxt_pEjIo7csd1 from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/v-gsap-nuxt/dist/runtime/nuxt.js";
import i18n_Fspu1Dj02B from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/nuxt-site-config/dist/runtime/plugins/i18n.mjs";
import plugin_ghbUAjaD3n from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import vue_datepicker_plugin_3Kygh7M1Wf from "/home/vsts/work/1/s/webapp-ots-nuxt/plugins/vue-datepicker.plugin.ts";
import vue_gtag_plugin_OPIcdkRTEm from "/home/vsts/work/1/s/webapp-ots-nuxt/plugins/vue-gtag.plugin.ts";
import analytics_client_mtqVw3YRXk from "/home/vsts/work/1/s/webapp-ots-nuxt/plugins/analytics.client.ts";
import gsap_client_YCLjR5XmPz from "/home/vsts/work/1/s/webapp-ots-nuxt/plugins/gsap.client.ts";
import ssg_detect_3fHkBxLtv0 from "/home/vsts/work/1/s/webapp-ots-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/ssg-detect.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_9gMxCtyFUG,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  switch_locale_path_ssr_5csfIgkrBP,
  route_locale_detect_VrpP1JaYg8,
  i18n_sq1MuCrqbC,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  nuxt_pEjIo7csd1,
  i18n_Fspu1Dj02B,
  plugin_ghbUAjaD3n,
  vue_datepicker_plugin_3Kygh7M1Wf,
  vue_gtag_plugin_OPIcdkRTEm,
  analytics_client_mtqVw3YRXk,
  gsap_client_YCLjR5XmPz,
  ssg_detect_3fHkBxLtv0
]